import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachemavenComponent } from './simple-icons-apachemaven.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachemavenComponent ],
    exports:      [ SimpleIconsApachemavenComponent ],
    bootstrap:    []
})
export class SimpleIconsApachemavenModule {}
